import config from '../config'
export default {
  apiUrl: 'http://yoursite.com/api/',
};

const siteConfig = {
  siteName: config.appName,
  siteIcon: 'ion-flash',
  footerText: 'YEEGEE ADMIN ©2021',
};
const themeConfig = {
  topbar: 'themedefault',
  sidebar: 'themedefault',
  layout: 'themedefault',
  theme: 'themedefault',
};
const language = 'english';

const jwtConfig = {
  fetchUrl: '/api/',
  secretKey: 'secretKey',
};

export { siteConfig, language, themeConfig, jwtConfig };
